import TextModel from "../models/text"


export const state = () => ({
    error: false,
    error_msg: null,
    loading: false,
    loaded: false
})

export const getters = {
    error: state => state.error,
    error_msg: state => state.error_msg,
    loading: state => state.loading,
    loaded: state => state.loaded
}

export const mutations = {
    load(state, data) {
        if (typeof data !== "object") {
            state.loading = false
            state.error = true
            state.error_msg = "ERROR: text data is missing or not an array."
            return;
        }

        var status = TextModel.hydrate(data);
        if (status.success){
            state.loading = false
            state.loaded = true
        } else {
            state.error = true
            state.error_msg = status.message
        }
    },
    setLoading(state, status) {
        state.loading = status
    }
}

export const actions = {
    load({commit, state}) {
        if(state.loaded) {
            return
        }

        commit('setLoading', true)
        const data = require("@/assets/data/text.json");
        commit('load', data)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
